// src/components/FeaturedProjects.jsx
import React from "react";
import { FiArrowUpRight } from "react-icons/fi";
import "./FeaturedProjects.css";

const projects = [
  // 
  {
    title: "Solana Mint Hub",
    description: "An NFT minting launchpad for creators and degen founders.",
    image: "https://images.unsplash.com/photo-1611926653454-3f1e1e7c1b9e",
    link: "https://github.com/WebCraft-Collective/solana-mint-hub",
  },
  {
    title: "DAO Dashboard",
    description: "Full-featured DAO governance and treasury platform.",
    image: "https://images.unsplash.com/photo-1611926653454-3f1e1e7c1b9e",
    link: "https://github.com/WebCraft-Collective/dao-dashboard",
  },
];

const FeaturedProjects = () => (
  <section className="featured-projects">
    <h2 className="section-title">Featured Projects</h2>
    <div className="project-cards">
      {projects.map((project, index) => (
        <div key={index} className="project-card">
          <img
            src={project.image}
            alt={project.title}
            className="project-image"
          />
          <div className="project-content">
            <h3>{project.title}</h3>
            <p>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer">
              Learn More <FiArrowUpRight />
            </a>
          </div>
        </div>
      ))}
    </div>
  </section>
);

export default FeaturedProjects;
